import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { getToken } from '../../../services/LocalStorageService';
import { useOrganisationIdMutation, useNetworksMutation, useAddPropertyMutation } from '../../../services/dvagent';
import { Toaster } from '../attributes';

export default function Add() {

  const [propertyName, setPropertyName] = React.useState('');
  const [appIdentifier, setAppIdentifier] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [networkLoad, setNetworkLoad] = React.useState(false);
  const [apikey, setAPikey] = React.useState("");
  const [alexa, setAlexa] = React.useState(0);
  const [organisation, setOrganisation] = React.useState("");
  const [networkList, setNetworkList] = React.useState([]);
  const [selectedNetwork, setSelectedNetwork] = React.useState("");
  const [selectedNetworkList, setSelectedNetworkList] = React.useState([]);
  const [organisationList, setOrganisationList] = React.useState([]);
  const [propertyNameError, setPropertyNameError] = React.useState("");
  const [appIdentifierError, setAppIdentifierError] = React.useState("");
  const [locationError, setLocationError] = React.useState("");
  const [apiKeyError, setApiKeyError] = React.useState("");
  const [organisationError, setOrganisationError] = React.useState("");
  const [networks] = useNetworksMutation();
  const [organisationId] = useOrganisationIdMutation();
  const [addProperty] = useAddPropertyMutation();
  const navigate = useNavigate();
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handlePropertyName = (event) => {
    setPropertyName(event.target.value);
    setPropertyNameError("");
  }

  const handleAppIdentifier = (event) => {
    setAppIdentifier(event.target.value);
    setAppIdentifierError("");
  }

  const handleLocation = (event) => {
    setLocation(event.target.value);
    setLocationError("");
  }

  const handleAlexa = (event) => {
    setAlexa(event.target.value);
  }

  const handleDisplayName = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, displayName: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleApplicationID = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, appId: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleSAMTag = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, tag_dv: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleMaintenanceTag = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, tag_maintenance: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleOrganisationId = async (value) => {
    setNetworkLoad(false);
    setAPikey(value);
    setApiKeyError("");
    if (value.length >= 40) {
      const actualData = {
        apiKey: value,
        token: getToken()
      }
      const res = await organisationId(actualData)
      if (res.error) {
        if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Something went wrong, unable to fetch the organisation');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
        setApiKeyError('Invalid api key.');
        setOrganisationList([]);
        setNetworkList([]);
        setOrganisation('');
        return
      }
      if (res.data) {
        if (res.data.data.errors) {
          setApiKeyError('Invalid api key.');
          setOrganisationList([]);
          setNetworkList([]);
          setOrganisation('');
        } else {
          setOrganisationList(res.data.data);
          setNetworkList([]);
          setOrganisation('');
        }
      }
    } else {
      setOrganisationList([]);
      setNetworkList([]);
      setOrganisation('');
    }
  }

  const handleNetworks = async (value) => {
    setNetworkLoad(true);
    setOrganisation(value);
    setOrganisationError("");
    setNetworkList([]);
    setSelectedNetworkList([]);
    const actualData = {
      apiKey: apikey,
      organisationId: value,
      token: getToken()
    }
    const res = await networks(actualData)
    if (res.error) {
      if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Something went wrong, unable to fetch the network');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      if (res.data.data.errors) {
        showToast(false, 'ⓘ', res.data.data.errors[0]);
      } else {
        setNetworkList(res.data.data)
        setNetworkLoad(false);
      }
    }
  }

  const handleAdd = async () => {

    if (!propertyName) {
      setPropertyNameError('Please enter property name.');
    }
    if (!location) {
      setLocationError('Please enter property location.');
    }
    if (!apikey) {
      setApiKeyError('Please enter property API key.');
    }
    if (!organisation) {
      setOrganisationError('Please select an organisation.');
    }
    if (!propertyName || !location || !apikey || !organisation) {
      return;
    }

    const actualData = {
      data: {
        "name": propertyName,
        "application_identifier": "null",
        "location": location,
        "api_key": apikey,
        "is_alexa": alexa,
        "organisation_id": organisation,
        "network": selectedNetworkList 
      },
      token: getToken()
    }
    const res = await addProperty(actualData);

    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Property already exists');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      showToast(true, '✔', 'Property added');
      setTimeout(() => {
        navigate('/cloud/properties');
      }, 3000);
    }
  }

  const handleAddToSelectedNetworkList = (id) => {
    const itemToAdd = networkList.find(item => item.id === id);
    if (itemToAdd) {
      setSelectedNetworkList([...selectedNetworkList, itemToAdd]);
      setNetworkList(networkList.filter(item => item.id !== id));
    }
  };

  const handleAddToNetworkList = (id) => {
    const itemToAdd = selectedNetworkList.find(item => item.id === id);
    if (itemToAdd) {
      setNetworkList([...networkList, itemToAdd]);
      setSelectedNetworkList(selectedNetworkList.filter(item => item.id !== id));
    }
  };


  const handleCancel = () => {
    navigate('/cloud/properties');
  }

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <TextField
            label="Property Name"
            variant="outlined"
            size="small"
            defaultValue={propertyName}
            onChange={handlePropertyName}
            helperText={propertyNameError}
            error={Boolean(propertyNameError)}
            autoComplete="off"
            inputProps={{ maxLength: 30 }}
          />
        </FormControl>
      </Grid>

      {/* <Grid item xs={12} sm={6} md={4} xl={4}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <TextField
            label="Application Identifier"
            variant="outlined"
            size="small"
            defaultValue={appIdentifier}
            onChange={handleAppIdentifier}
            helperText={appIdentifierError}
            error={Boolean(appIdentifierError)}
            autoComplete="off"
          />
        </FormControl>
      </Grid> */}

      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <TextField
            label="Location"
            variant="outlined"
            size="small"
            defaultValue={location}
            onChange={handleLocation}
            helperText={locationError}
            error={Boolean(locationError)}
            autoComplete="off"
            inputProps={{ maxLength: 30 }}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <TextField
            label="API Key"
            variant="outlined"
            size="small"
            defaultValue={apikey}
            type="password"
            onChange={(event) => handleOrganisationId(event.target.value)}
            helperText={apiKeyError}
            error={Boolean(apiKeyError)}
            autoComplete="off"
          />
        </FormControl>
      </Grid>

      {/* <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <InputLabel id="demo-select-small-label">Alexa</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            defaultValue={alexa}
            label="Alexa"
            onChange={handleAlexa}
          >
            <MenuItem value={0}>Disabled</MenuItem>
            <MenuItem value={1}>Enabled</MenuItem>
          </Select>
        </FormControl>
      </Grid> */}

      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 3 }} fullWidth size="small">
          <InputLabel id="demo-select-small-label">Organisations Name</InputLabel>
          <Select
            labelId="demo-select-small-label"
            id="demo-select-small"
            value={organisation}
            label="OrganisationsName"
            disabled = {networkLoad ? 1:0}
            onChange={(event) => handleNetworks(event.target.value)}
            error={Boolean(organisationError)}
          >
            {organisationList.map(item =>
              <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
            )}
          </Select>
          <FormHelperText sx={{ color: '#EB4C49' }}>{organisationError}</FormHelperText>
        </FormControl>
      </Grid>

      {networkLoad && (
        <Grid item xs={12} sm={12} md={12} xl={4}>
          <Skeleton animation="wave" height={70} width="100%" />
        </Grid>
      )}

      {networkList.length > 0 && (
        <>
          <Grid item xs={9} sm={10} md={9} xl={3}>
            <FormControl sx={{ mb: 3 }} fullWidth size="small">
              <InputLabel id="demo-select-small-label">Networks</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={selectedNetwork}
                label="Networks"
                onChange={(event) => setSelectedNetwork(event.target.value)}
              >
                {networkList.map((item) =>
                  <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={2} md={3} xl={1}>
            <FormControl fullWidth>
              <Button
                onClick={() => handleAddToSelectedNetworkList(selectedNetwork)}
                sx={{
                  color: '#FFF',
                  border: 1,
                  borderColor: '#A8A196',
                  bgcolor: '#A8A196',
                  ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                }}}>
                <Icon height={25} color="#EEEDED" icon="fluent:add-20-regular" />
              </Button>
            </FormControl>
          </Grid>
        </>
      )}

      {selectedNetworkList.length > 0 && (
        <Grid item xs={12}>
          <Typography color="text.secondary" sx={{ mb: 2, fontSize: 14, fontWeight: 'bold' }}>
            CONFIGURE PROPERTY NETWORK
          </Typography>
        </Grid>
      )}

      {selectedNetworkList.map((item, index) =>
        <Container key={item.id} maxWidth="xxl" sx={{
          border: 1,
          borderRadius: '8px',
          marginLeft: '15px',
          marginBottom: '15px',
          borderColor: '#f2f0eb',
          borderLeft: 5,
          borderLeftColor: '#A8A196',
          borderRight: 5,
          borderRightColor: '#A8A196'
        }}>
          <Grid container spacing={2}>

            <Grid item xs={12} sm={6} md={3} xl={3}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Display Name"
                  variant="outlined"
                  size="small"
                  defaultValue={item.displayName}
                  onChange={(event) => handleDisplayName(event, index)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3} xl={3}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Network ID"
                  variant="outlined"
                  size="small"
                  disabled
                  id="outlined-disabled"
                  defaultValue={item.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3} xl={3}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Network name"
                  variant="outlined"
                  size="small"
                  disabled
                  id="outlined-disabled"
                  defaultValue={item.name}
                />
              </FormControl>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} xl={4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <InputLabel id="demo-select-small-label">SAM Tag</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="SAMTag"
                  value={item.tag_dv}
                  onChange={(event) => handleSAMTag(event, index)}
                >
                  {item.tags.map(items =>
                    <MenuItem value={items} key={index}>{items}</MenuItem>
                  )} 
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <InputLabel id="demo-select-small-label">Maintenance SAM Tag</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="MaintenanceSAMTag"
                  value={item.tag_maintenance}
                  onChange={(event) => handleMaintenanceTag(event, index)}
                >
                  {item.tags.map(items =>
                    <MenuItem value={items} key={item.id}>{items}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={10} md={3} xl={3}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Application ID"
                  variant="outlined"
                  size="small"
                  defaultValue={item.appId}
                  onChange={(event) => handleApplicationID(event, index)}
                />
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={6} md={3} xl={3}>
              <FormControl sx={{ my: 1 }} fullWidth>
                <Button
                  onClick={() => handleAddToNetworkList(item.id)}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#E74646',
                    bgcolor: '#E74646',
                    ":hover": {
                        bgcolor: "#BB2525",
                        borderColor: '#BB2525',
                    }
                  }}>
                  <Icon height={25} color="#EEEDED" icon="fluent:delete-20-regular" />
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      )}

      {selectedNetworkList.length > 0 && (
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
              <Button
                onClick={() => handleAdd()}
                  sx={{
                  color: '#FFF',
                  border: 1,
                  borderColor: '#A8A196',
                  bgcolor: '#A8A196',
                  marginRight:2,
                  ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                  }
                }}>
                ADD
              </Button>
            </FormControl>
            <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
              <Button
                onClick={handleCancel}
                sx={{
                  color: '#9BA4B5',
                  border: 1,
                  borderColor: '#B5C0D0',
                  bgcolor: '#FFF',
                  ":hover": {
                      bgcolor: "#EEEEEE",
                      borderColor: '#EEEEEE',
                  }
                }}
                >
                Back
              </Button>
            </FormControl>
          </Box>
        </Grid>
      )}
    </>
  );
}